module.exports = __webpack_public_path__ + "img/delay_9.315d41bc.svg";